export const NOMNOM_URL: string = process.env.REACT_APP_URL!;
export const NOMNOM_HUB_SHOPPING_LIST_INGREDIENT: string = process.env.REACT_APP_HUB_SHOPPING_LIST_INGREDIENT!;